import { Arbitro, ArbitroJSON } from '../Arbitro/Arbitro';
import { Partido, PartidoJSON } from '../Partido/Partido';
import {
  PlanillaPartidoJugadorJSON,
  PlanillaPartidoJugador,
} from '../PlanillaPartidoJugador/PlanillaPartidoJugador';
import {
  PlanillaPartidoOficialJSON,
  PlanillaPartidoOficial,
} from '../PlanillaPartidoOficial/PlanillaPartidoOficial';
import {
  PlanillaPartidoOficialAuxiliarJSON,
  PlanillaPartidoOficialAuxiliar,
} from '../PlanillaPartidoOficialAuxiliar/PlanillaPartidoOficialAuxiliar';
import {
  PlanillaPartidoOficialMesaNoRegsitradoJSON,
  PlanillaPartidoOficialMesaNoRegsitrado,
} from '../PlanillaPartidoOficialMesaNoRegsitrado/PlanillaPartidoOficialMesaNoRegsitrado';

export interface PlanillaPartidoJSON {
  pp_id: string | null;
  pp_parid: number;
  pp_arbid_1: number;
  pp_arbid_2: number;
  pp_fecha_hora_inicio: Date;
  pp_cjid: number;
  pp_ofmid_local: number | null;
  pp_ofmid_visitante: number | null;
  pp_goles_local: number;
  pp_goles_visitante: number;
  pp_diferido: any;
  pp_observacion: any;
  pp_informe: any;
  pp_estado: string;
  pp_usid_carga: number;
  pp_fecha_carga: Date;
  pp_puede_empatar: boolean;
  pp_suspendida: boolean;

  __v: string;

  pp_url_transmision: string;

  partido: PartidoJSON;
  arbitro1: ArbitroJSON;
  arbitro2: ArbitroJSON | null;
  planillaPartidoJugadorList: PlanillaPartidoJugadorJSON[];
  planillaPartidoOficialList: PlanillaPartidoOficialJSON[];
  planillaPartidoOficialAuxiliarList: PlanillaPartidoOficialAuxiliarJSON[];
  planillaPartidoOficialMesaNoRegistradoList: PlanillaPartidoOficialMesaNoRegsitradoJSON[];
}

const PENDING_CONFIRMATION_STATE = 'Pend. Confirmación';
const INGAME_STATE = 'En juego';
const INICIADA_STATE = 'Iniciada';
const FINALIZADA_STATE = 'Finalizada';
const FINALIZADA_SUSPENDIDA_STATE = 'Finalizada suspendida';

export class PlanillaPartido {
  protected constructor(
    private id: string | null,
    private parid: number,
    private arbid1: number,
    private arbid2: number,
    private fechaHoraInicio: Date,
    private cjid: number,
    private ofmidLocal: number,
    private ofmidVisitante: number,
    private golesLocal: number,
    private golesVisitante: number,
    private diferido: any,
    private observacion: any,
    private informe: any,
    private estado: string,
    private usidCarga: number,
    private fechaCarga: Date,
    private puedeEmpatar: boolean,
    private suspendida: boolean,

    private __v: string,

    private urlTransmision: string,

    private partido: Partido,
    private arbitro1: Arbitro,
    private arbitro2: Arbitro | null,
    private planillaPartidoJugadorList: PlanillaPartidoJugador[],
    private planillaPartidoOficialList: PlanillaPartidoOficial[],
    private planillaPartidoOficialAuxiliarList: PlanillaPartidoOficialAuxiliar[],
    private planillaPartidoOficialMesaNoRegistradoList: PlanillaPartidoOficialMesaNoRegsitrado[]
  ) {}

  prepareForSaveFromPlanillaOnline(
    golesLocal: number,
    golesVisitante: number,
    informe: boolean,
    observaciones: string
  ) {
    this.golesLocal = golesLocal;
    this.golesVisitante = golesVisitante;
    this.observacion = observaciones;
    this.informe = informe;
  }

  static createFrom(
    id: string | null,
    parid: number,
    arbid1: number,
    arbid2: number,
    fechaHoraInicio: Date,
    cjid: number,
    ofmidLocal: number,
    ofmidVisitante: number,
    golesLocal: number,
    golesVisitante: number,
    diferido: any,
    observacion: any,
    informe: any,
    estado: string,
    usidCarga: number,
    fechaCarga: Date,
    puedeEmpatar: boolean,
    suspendida: boolean,

    __v: string,

    urlTransmision: string,

    partido: Partido,
    arbitro1: Arbitro,
    arbitro2: Arbitro | null,
    planillaPartidoJugadorList: PlanillaPartidoJugador[],
    planillaPartidoOficialList: PlanillaPartidoOficial[],
    planillaPartidoOficialAuxiliarList: PlanillaPartidoOficialAuxiliar[],
    planillaPartidoOficialMesaNoRegistradoList: PlanillaPartidoOficialMesaNoRegsitrado[]
  ) {
    return new this(
      id,
      parid,
      arbid1,
      arbid2,
      fechaHoraInicio,
      cjid,
      ofmidLocal,
      ofmidVisitante,
      golesLocal,
      golesVisitante,
      diferido,
      observacion,
      informe,
      estado,
      usidCarga,
      fechaCarga,
      puedeEmpatar,
      suspendida,

      __v,

      urlTransmision,

      partido,
      arbitro1,
      arbitro2,
      planillaPartidoJugadorList,
      planillaPartidoOficialList,
      planillaPartidoOficialAuxiliarList,
      planillaPartidoOficialMesaNoRegistradoList
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: PlanillaPartido) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: PlanillaPartidoJSON) {
    return PlanillaPartido.createFrom(
      entity.pp_id,
      entity.pp_parid,
      entity.pp_arbid_1,
      entity.pp_arbid_2,
      new Date(entity.pp_fecha_hora_inicio),
      entity.pp_cjid,
      entity.pp_ofmid_local ? entity.pp_ofmid_local : 0,
      entity.pp_ofmid_visitante ? entity.pp_ofmid_visitante : 0,
      entity.pp_goles_local,
      entity.pp_goles_visitante,
      entity.pp_diferido,
      entity.pp_observacion,
      entity.pp_informe,
      entity.pp_estado,
      entity.pp_usid_carga,
      new Date(entity.pp_fecha_carga),
      entity.pp_puede_empatar,
      entity.pp_suspendida,

      entity.__v,

      entity.pp_url_transmision,

      Partido.fromJSON(entity.partido),
      Arbitro.fromJSON(entity.arbitro1),
      entity.arbitro2 ? Arbitro.fromJSON(entity.arbitro2) : null,
      entity.planillaPartidoJugadorList
        ? entity.planillaPartidoJugadorList.map((e) => PlanillaPartidoJugador.fromJSON(e))
        : [],
      entity.planillaPartidoOficialList
        ? entity.planillaPartidoOficialList.map((e) => PlanillaPartidoOficial.fromJSON(e))
        : [],
      entity.planillaPartidoOficialAuxiliarList
        ? entity.planillaPartidoOficialAuxiliarList.map((e) => PlanillaPartidoOficialAuxiliar.fromJSON(e))
        : [],
      entity.planillaPartidoOficialMesaNoRegistradoList
        ? entity.planillaPartidoOficialMesaNoRegistradoList.map((e) =>
            PlanillaPartidoOficialMesaNoRegsitrado.fromJSON(e)
          )
        : []
    );
  }

  getSuspendida() {
    return this.suspendida;
  }

  toJSON(): PlanillaPartidoJSON {
    return {
      pp_id: this.getId(),
      pp_parid: this.getParid(),
      pp_arbid_1: this.getArbid1(),
      pp_arbid_2: this.getArbid2(),
      pp_fecha_hora_inicio: this.getFechaHoraInicio(),
      pp_cjid: this.getCjid(),
      pp_ofmid_local: this.getOfmidLocal() ? this.getOfmidLocal() : null,
      pp_ofmid_visitante: this.getOfmidVisitante() ? this.getOfmidVisitante() : null,
      pp_goles_local: this.getGolesLocal(),
      pp_goles_visitante: this.getGolesVisitante(),
      pp_diferido: this.getDiferido(),
      pp_observacion: this.getObservacion(),
      pp_informe: this.getInforme(),
      pp_estado: this.getEstado(),
      pp_usid_carga: this.getUsidCarga(),
      pp_fecha_carga: this.getFechaCarga(),
      pp_puede_empatar: this.getPuedeEmpatar(),
      pp_suspendida: this.getSuspendida(),

      __v: this.get__v(),

      pp_url_transmision: this.getUrlTransmision(),

      partido: this.getPartido().toJSON(),
      arbitro1: this.getArbitro1().toJSON(),
      arbitro2: this.getArbitro2() ? this.getArbitro2()!.toJSON() : null,
      planillaPartidoJugadorList: this.planillaPartidoJugadorList.map((e) => e.toJSON()),
      planillaPartidoOficialList: this.planillaPartidoOficialList.map((e) => e.toJSON()),
      planillaPartidoOficialAuxiliarList: this.planillaPartidoOficialAuxiliarList.map((e) => e.toJSON()),
      planillaPartidoOficialMesaNoRegistradoList: this.planillaPartidoOficialMesaNoRegistradoList.map((e) =>
        e.toJSON()
      ),
    };
  }

  addPlanillaPartidoJugadorToList(ppj: PlanillaPartidoJugador) {
    this.planillaPartidoJugadorList.push(ppj);
  }

  pendingConfirmation() {
    return this.estado === PENDING_CONFIRMATION_STATE;
  }

  enJuego() {
    return this.estado === INGAME_STATE;
  }

  iniciada() {
    return this.estado === INICIADA_STATE;
  }

  finalizada() {
    return this.estado === FINALIZADA_STATE || this.estado === FINALIZADA_SUSPENDIDA_STATE;
  }

  getId(): string | null {
    return this.id;
  }

  getParid(): number {
    return this.parid;
  }

  getArbid1(): number {
    return this.arbid1;
  }

  getArbid2(): number {
    return this.arbid2;
  }

  getFechaHoraInicio(): Date {
    return this.fechaHoraInicio;
  }

  getCjid(): number {
    return this.cjid;
  }

  get__v(): string {
    return this.__v;
  }

  set__v(v: string) {
    this.__v = v;
  }

  getUrlTransmision() {
    return this.urlTransmision;
  }

  getOfmidLocal(): number {
    return this.ofmidLocal;
  }

  getOfmidVisitante(): number {
    return this.ofmidVisitante;
  }

  getGolesLocal(): number {
    return this.golesLocal;
  }

  getGolesVisitante(): number {
    return this.golesVisitante;
  }

  getDiferido(): any {
    return this.diferido;
  }

  getObservacion(): any {
    return this.observacion;
  }

  getInforme(): any {
    return this.informe;
  }

  getEstado(): string {
    return this.estado;
  }

  getUsidCarga(): number {
    return this.usidCarga;
  }

  getFechaCarga(): Date {
    return this.fechaCarga;
  }

  getPuedeEmpatar(): boolean {
    return this.puedeEmpatar;
  }

  getPartido(): Partido {
    return this.partido;
  }

  getArbitro1(): Arbitro {
    return this.arbitro1;
  }

  getArbitro2(): Arbitro | null {
    return this.arbitro2;
  }

  getPlanillaPartidoJugadorList() {
    return this.planillaPartidoJugadorList;
  }
  getPlanillaPartidoOficialList() {
    return this.planillaPartidoOficialList;
  }
  getPlanillaPartidoOficialAuxiliarList() {
    return this.planillaPartidoOficialAuxiliarList;
  }
  getPlanillaPartidoOficialMesaNoRegistradoList() {
    return this.planillaPartidoOficialMesaNoRegistradoList;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setParid(value: number): void {
    this.parid = value;
  }

  setArbid1(value: number): void {
    this.arbid1 = value;
  }

  setArbid2(value: number): void {
    this.arbid2 = value;
  }

  setFechaHoraInicio(value: Date): void {
    this.fechaHoraInicio = value;
  }

  setCjid(value: number): void {
    this.cjid = value;
  }

  setOfmidLocal(value: number): void {
    this.ofmidLocal = value;
  }

  setOfmidVisitante(value: number): void {
    this.ofmidVisitante = value;
  }

  setGolesLocal(value: number): void {
    this.golesLocal = value;
  }

  setGolesVisitante(value: number): void {
    this.golesVisitante = value;
  }

  setDiferido(value: any): void {
    this.diferido = value;
  }

  setObservacion(value: any): void {
    this.observacion = value;
  }

  setInforme(value: any): void {
    this.informe = value;
  }

  setEstado(value: string): void {
    this.estado = value;
  }

  setUsidCarga(value: number): void {
    this.usidCarga = value;
  }

  setFechaCarga(value: Date): void {
    this.fechaCarga = value;
  }

  setPuedeEmpatar(value: boolean): void {
    this.puedeEmpatar = value;
  }
}
